import React from "react";
import ReactPlayer from "react-player";

interface VideoPlayerProps {
    url: string;
}

export default function VideoPlayer({ url }: VideoPlayerProps) {
    return (
        <div className="w-full max-w-4xl aspect-video border-2 border-gray-300 overflow-hidden ">
            <ReactPlayer
                url={url}
                controls
                width="100%"
                height="100%"
            />
        </div>
    );
}
